import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import GameDetailsPage from './pages/GameDetailsPage';
import SearchPage from './pages/SearchPage';
import GenrePage from './pages/GenrePage';
import GenresPage from './pages/GenresPage';
import CategoryPage from './pages/CategoryPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />
          
          {/* Game Details */}
          <Route path="/game/:gamePath" element={<GameDetailsPage />} />
          
          {/* Search */}
          <Route path="/search" element={<SearchPage />} />
          
          {/* Genres */}
          <Route path="/genres" element={<GenresPage />} />
          <Route path="/genre/:genre" element={<GenrePage />} />
          
          {/* Categories */}
          <Route path="/repack" element={<CategoryPage key="repack" category="repack" />} />
          <Route path="/online" element={<CategoryPage key="online" category="online" />} />
          <Route path="/updates" element={<CategoryPage key="updates" category="updates" />} />
          
          {/* 404 */}
          <Route path="*" element={
            <div className="min-h-screen bg-gray-50 dark:bg-dark-900 flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                  404
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mb-6">
                  Page non trouvée
                </p>
                <a
                  href="/"
                  className="bg-primary-600 text-white px-6 py-2 rounded-lg hover:bg-primary-700 transition-colors"
                >
                  Retour à l'accueil
                </a>
              </div>
            </div>
          } />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
